import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

interface User {
  username: string;
  email: string;
  admin: boolean;
  loggedIn: boolean;
}

interface Userdata {
  username: string;
  email: string;
  role: string;
}

const store = new Vuex.Store({
  state: {
    currentUserToken: "",
    currentUser: {} as User
  },

  mutations: {
    initialize(state): void {
      const savedStore = localStorage.getItem("store");
      if (savedStore) {
        this.replaceState(Object.assign(state, JSON.parse(savedStore)));
      }
    },

    saveToken(state, token: string): void {
      if (token) {
        state.currentUserToken = token;
      }
    },

    setUser(state, user: Userdata): void {
      state.currentUser = {
        username: user.username,
        email: user.email,
        admin: user.role === "admin" ? true : false,
        loggedIn: true
      };
    },

    clearUser(state): void {
      state.currentUser = {} as User;
      state.currentUserToken = "";
    }
  },

  actions: {
    async setUser(context, token: string): Promise<void> {
      context.commit("saveToken", token);
      const response = await fetch(process.env.VUE_APP_API_URL + "/user", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.state.currentUserToken
        }
      });
      const result = await response.json();
      context.commit("setUser", result.data);
    }
  },

  modules: {
  }
});

store.subscribe((mutation, state) => {
  localStorage.setItem("store", JSON.stringify(state));
});

export default store;